export default {
  promotions: (state: any) => state.promotions,
  letters: (state: any) => state.letters,
  lettersCount: (state: any) => state.lettersCount,
  bonuses: (state: any) => state.bonuses,
  bonusesCount: (state: any) => state.bonusesCount,
}
